import {RemoteAiContentGenerationSetup, RemoteImageEditMode, AiImageEditMode} from 'common/src/modules/contentFeeds/contentFeeds.aiContentTypes';
import aiImagesApi from 'common/src/modules/aiImages/aiImages.api';
import {GenAIActionType, ProductShotType} from 'common/src/modules/aiImages/aiImages.enums';
import {GenerationSetupToolInput, ProductShotTypeSelection} from './generationSetupToolSchemas';

async function buildRemoteGenerationSetupFromToolInput(
  generationSetup: GenerationSetupToolInput,
): Promise<RemoteAiContentGenerationSetup> {
  let vendorService: number | null = null;
  let vendorServiceWithReferences: number | null = null;

  if (generationSetup.imageAiGeneration) {
    try {
      const servicesPerAction = await aiImagesApi.getServicePerAction();
      const promptToImageService = servicesPerAction[GenAIActionType.PromptToImage];

      if (promptToImageService?.services && promptToImageService.services.length > 0) {
        vendorService = promptToImageService.services[0].value;
      }

      const promptToImageWithRefsService =
        servicesPerAction[GenAIActionType.PromptToImageWithReferenceImages];

      if (
        promptToImageWithRefsService?.services &&
        promptToImageWithRefsService.services.length > 0
      ) {
        vendorServiceWithReferences = promptToImageWithRefsService.services[0].value;
      }
    } catch (error) {
      console.error('Error fetching vendor services:', error);
    }
  }

  return {
    imageSmartCrop: generationSetup.imageSmartCrop
      ? {
          inputColumnName: generationSetup.imageSmartCrop.inputColumnName ?? null,
          objectDetectPrompt: generationSetup.imageSmartCrop.objectDetectPrompt ?? null,
          marginPercent: generationSetup.imageSmartCrop.marginPercent,
        }
      : null,
    imageAiGeneration: generationSetup.imageAiGeneration
      ? {
          usedInputColumns: generationSetup.imageAiGeneration.usedInputColumns
            ? generationSetup.imageAiGeneration.usedInputColumns.map((col) => ({
                columnName: col.columnName,
              }))
            : null,
          vendorService,
          vendorServiceWithReferences,
          useSharedIntermediateImage:
            generationSetup.imageAiGeneration.useSharedIntermediateImage ?? false,
        }
      : null,
    productShotGeneration:
      generationSetup.productShotGeneration &&
      Object.keys(generationSetup.productShotGeneration).length > 0
        ? {
            productImageInputColumnName:
              generationSetup.productShotGeneration.productImageInputColumnName ?? null,
            ScenePromptInputColumnName: generationSetup.productShotGeneration.ScenePromptInputColumnName
              ? generationSetup.productShotGeneration.ScenePromptInputColumnName.map((col) => ({
                  columnName: col.columnName,
                }))
              : null,
            OptionalSceneReferenceImageInputColumnName:
              generationSetup.productShotGeneration.OptionalSceneReferenceImageInputColumnName ??
              null,
            marginPercent: generationSetup.productShotGeneration.marginPercent,
            productType:
              generationSetup.productShotGeneration.productType === ProductShotTypeSelection.Product
                ? ProductShotType.Product
                : ProductShotType.Vehicle,
            useSharedIntermediateImage:
              generationSetup.productShotGeneration.useSharedIntermediateImage ?? false,
          }
        : null,
    textGeneration: generationSetup.textGeneration
      ? {
          usedInputColumns: generationSetup.textGeneration.usedInputColumns
            ? generationSetup.textGeneration.usedInputColumns.map((col) => ({
                columnName: col.columnName,
              }))
            : null,
        }
      : null,
    imageEdit: generationSetup.imageEdit
      ? {
          inputImageColumnName: generationSetup.imageEdit.inputImageColumnName ?? null,
          stylePromptInputColumns: generationSetup.imageEdit.stylePromptInputColumns
            ? generationSetup.imageEdit.stylePromptInputColumns.map((col) => ({
                columnName: col.columnName,
              }))
            : null,
          editMode: generationSetup.imageEdit.editMode != null
            ? RemoteImageEditMode[generationSetup.imageEdit.editMode as AiImageEditMode]
            : RemoteImageEditMode.General,
        }
      : null,
  };
}

export default buildRemoteGenerationSetupFromToolInput;
